import { useMutation } from 'react-query';

import { useRequest } from '@frontend/api';
import type { MutationFunction } from '@frontend/api';

import type {
  BulkDeleteQuoteFilesQueryVars,
  UseBulkDeleteQuoteFilesParams,
} from './types';

export const useBulkDeleteQuoteFiles: MutationFunction<
  null,
  BulkDeleteQuoteFilesQueryVars,
  [UseBulkDeleteQuoteFilesParams]
> = (params, { requestOptions, queryOptions } = {}) => {
  const { quoteId } = params;
  const urlPath = `/quotes/files/${quoteId}/bulk_delete`;
  const request = useRequest(requestOptions);

  return useMutation(
    (requestData) =>
      request(urlPath, {
        init: { method: 'DELETE', body: requestData },
      }),
    {
      ...queryOptions,
      mutationKey: ['quotes', 'quoteFiles', 'bulkDelete', params],
    },
  );
};
